/**
 * Called from StoreLoader.
 * StoreLaoder is placed in the top level of the app and has access to
 * usePage() from onMounted();
 *
 * Here we're reading all of the store modules in this directory,
 * initializing them, and returning an object with all of the store instances.
 */

import type { AppProps } from '@/types/appTypes';

const modules = import.meta.glob('./use*.ts', { eager: true });

let storesCache: Record<string, any> | null = null;

export const initStores = () => {
    if (storesCache) {
        // console.log('✅ Cache hit, keys:', Object.keys(storesCache));
        return storesCache;
    }

    // console.log('🔍 Modules found:', Object.keys(modules));

    const stores: Record<string, any> = {};
    // console.log('Initializing stores...');

    for (const path in modules) {
        // console.log('📁 Processing:', path);  THIS
        const mod = modules[path] as any;
        // console.log('📦 Exports:', Object.keys(mod));

        for (const key in mod) {
            // console.log('🔑 Key:', key, typeof mod[key]);
            if (key.startsWith('use') && typeof mod[key] === 'function') {
                // console.log('🟢 Creating store:', key);
                stores[key] = mod[key]();
            }
        }
    }

    // console.log('🏁 Final stores:', Object.keys(stores));
    storesCache = stores;
    return storesCache;
};

export const syncStoresFromProps = (props: AppProps) => {
    if (!storesCache) return;

    console.log('AppProps in Store Sync, from Server:', props);

     console.log('🟢 syncStoresFromProps START');
    // console.log('🟠 syncStoresFromProps dateRange input:', props.dateRange?.length);

    // ✅ EXPLICIT ORDER: schedule data exists before dateStore triggers recompute
    storesCache.useScheduleStore?.updateFromProps?.(props);
    // console.log('🟢 scheduleStore synced');

    storesCache.useDateStore?.updateFromProps?.(props);
    // console.log('🟢 dateStore synced');

    storesCache.useBookingStore?.updateFromProps?.(props);
    // console.log('🟢 bookingStore synced');


    storesCache.useOfflineSlotsStore?.updateFromProps?.(props);

    // console.log('🟢 syncStoresFromProps COMPLETE');

};

export type StoresType = ReturnType<typeof initStores>;
